import { css } from 'emotion';
import React from 'react';
import TextInput from '../../textInput/TextInput';
import { useTheme } from '../../theme-context';
import { ISummaryLine } from '../types';

interface IOrderSummaryCheckoutLine {
    summaryLine: ISummaryLine;
    currencySymbol?: string;
    setOrderSummaryTicketPriceAction: (
        ticketClassId: string,
        quantity: string,
    ) => void;
    syncCart: () => void;
}

const OrderSummaryCheckoutLine = ({
    summaryLine,
    currencySymbol,
    setOrderSummaryTicketPriceAction,
    syncCart,
}: IOrderSummaryCheckoutLine) => {
    const {
        ticketClassId,
        totalPrice,
        ticketPriceNumber,
        quantity,
        name,
        tier,
    } = summaryLine;

    const description = `${quantity}x ${name}`;
    const { getFont } = useTheme();

    return (
        <div>
            <div
                className={css({
                    alignItems: 'center',
                    display: 'grid',
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    gridTemplateColumns: '50% 50%',
                    padding: '16px 0px',
                })}
            >
                <div
                    className={css({
                        display: 'grid',
                        gridTemplateColumns: tier
                            ? 'fit-content(100%) 180px'
                            : 'fit-content(100%)',
                    })}
                >
                    {tier ? (
                        <div
                            data-testid="tier"
                            className={css({
                                background: tier,
                                alignSelf: 'center',
                                borderRadius: '50%',
                                width: '14px',
                                height: '14px',
                                marginRight: '4px',
                            })}
                        />
                    ) : null}

                    <div
                        data-testid="description"
                        className={css({
                            lineHeight: `${
                                getFont('desktop/body/medium').lineHeightPx
                            }px`,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        })}
                    >
                        {description}
                    </div>
                </div>
                <div
                    data-testid="quantity"
                    className={css({
                        alignItems: 'center',
                        display: 'grid',
                        marginLeft: 'auto',
                        textAlign: 'right',
                        width: '120px',
                    })}
                >
                    <TextInput
                        value=""
                        onChange={(value) =>
                            setOrderSummaryTicketPriceAction(
                                ticketClassId,
                                value,
                            )
                        }
                        onBlur={() => syncCart()}
                        placeholder={ticketPriceNumber}
                        prefix={currencySymbol}
                        data-testid="edit-total-price"
                    />
                </div>
                <div
                    data-testid="total-price"
                    className={css({
                        gridColumnStart: '2',
                        marginTop: '12px',
                        width: '100%',
                        textAlign: 'right',
                        lineHeight: `${
                            getFont('desktop/body/medium').lineHeightPx
                        }px`,
                    })}
                >
                    {totalPrice}
                </div>
            </div>
        </div>
    );
};

export default OrderSummaryCheckoutLine;
